import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsBasicStep.Notice', {
    notice: 'Every company needs to have at least one Director. Please add a Director to your company.',
});
